const initialState = {
    companyaddress: ''
  };
  
  const companyAddressReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_COMPANY_ADDRESS':
            return { ...state, companyaddress: action.payload };
        default:
            return state;
    }
  };
  
  export default companyAddressReducer;
  